(function () {
  var ATTRIBUTION_KEY = 'ov_affiliate_attribution_v2';
  var SYNC_KEY = 'ov_affiliate_cart_sync_v2';
  var SESSION_KEY = 'ov_affiliate_session_v1';
  var HEALTH_KEY = 'ov_affiliate_health_v1';
  var ATTRIBUTION_TTL = 30 * 24 * 60 * 60 * 1000;
  var HEALTH_TTL = 24 * 60 * 60 * 1000;
  var lastAddToCart = {key: '', at: 0};
  var cartHasItems = null;

  function storageGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {
      // Attribution still works for the current page when browser storage is blocked.
    }
  }

  function validSlug(value) {
    var slug = String(value || '').trim().toLowerCase();
    return /^[a-z0-9][a-z0-9_-]{0,99}$/.test(slug) ? slug : '';
  }

  function eventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'ovn-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  function sessionId() {
    var current = storageGet(window.sessionStorage, SESSION_KEY);
    if (current) return current;
    current = eventId();
    storageSet(window.sessionStorage, SESSION_KEY, current);
    return current;
  }

  function currentProductGid(detail) {
    var numericId = detail && detail.data && detail.data.productId;
    if (!numericId && window.ShopifyAnalytics && window.ShopifyAnalytics.meta) {
      numericId = window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.id;
    }
    if (!numericId) return null;
    var value = String(numericId);
    return value.indexOf('gid://') === 0 ? value : 'gid://shopify/Product/' + value;
  }

  function currentAttribution() {
    var params = new URLSearchParams(window.location.search);
    var explicitSlug = validSlug(params.get('affiliate_ref'));
    if (!explicitSlug && params.get('utm_source') === 'affiliate') {
      explicitSlug = validSlug(params.get('utm_content'));
    }

    if (explicitSlug) {
      var attribution = {
        slug: explicitSlug,
        campaign: validSlug(params.get('affiliate_campaign')) || validSlug(params.get('utm_campaign')),
        linkCode: validSlug(params.get('affiliate_link')),
        source: 'affiliate',
        capturedAt: Date.now(),
        isNew: true,
      };
      storageSet(window.localStorage, ATTRIBUTION_KEY, JSON.stringify(attribution));
      return attribution;
    }

    var stored = storageGet(window.localStorage, ATTRIBUTION_KEY);
    if (!stored) return null;

    try {
      var attribution = JSON.parse(stored);
      if (!validSlug(attribution.slug)) return null;
      if (Date.now() - Number(attribution.capturedAt || 0) > ATTRIBUTION_TTL) return null;
      attribution.slug = validSlug(attribution.slug);
      attribution.campaign = validSlug(attribution.campaign);
      attribution.linkCode = validSlug(attribution.linkCode);
      attribution.isNew = false;
      return attribution;
    } catch (error) {
      return null;
    }
  }

  function sendEvent(eventType, attribution, detail) {
    if (!attribution || !attribution.slug) return;
    var payload = {
      eventType: eventType,
      eventId: eventId(),
      affiliateSlug: attribution.slug,
      campaignSlug: attribution.campaign,
      linkCode: attribution.linkCode,
      sessionId: sessionId(),
      path: window.location.pathname + window.location.search,
      productGid: currentProductGid(detail),
      metadata: {
        referrer: String(document.referrer || '').slice(0, 500),
        source: detail && detail.data ? String(detail.data.source || '').slice(0, 100) : '',
        variantId: detail && detail.data ? String(detail.data.variantId || '').slice(0, 100) : '',
      },
    };

    fetch('/apps/affiliate?action=event', {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: eventType === 'checkout' || eventType === 'add_to_cart',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
      },
      body: JSON.stringify(payload),
    }).catch(function () {
      // Tracking must never interrupt storefront actions.
    });
  }

  function trackAddToCart(attribution, detail) {
    var data = detail && detail.data ? detail.data : {};
    var key = String(data.variantId || data.productId || '') + '|' + window.location.pathname;
    var now = Date.now();
    if (lastAddToCart.key === key && now - lastAddToCart.at < 1500) return;
    lastAddToCart = {key: key, at: now};
    sendEvent('add_to_cart', attribution, detail);
  }

  function updateCartState(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    cartHasItems = cart.item_count > 0;
  }

  function detailFromCartAdd(body, source) {
    var item = body && body.items && body.items.length ? body.items[0] : body;
    return {
      data: {
        source: source,
        productId: item && item.product_id ? item.product_id : '',
        variantId: item && item.variant_id ? item.variant_id : (item && item.id ? item.id : ''),
      },
    };
  }

  function installConfirmedCartTracking(attribution) {
    if (!attribution || !attribution.slug || typeof window.fetch !== 'function') return;
    var originalFetch = window.fetch.bind(window);

    originalFetch('/cart.js', {credentials: 'same-origin', headers: {accept: 'application/json'}})
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(updateCartState)
      .catch(function () {
        // Checkout tracking remains disabled until the cart is confirmed.
      });

    window.fetch = function () {
      var args = arguments;
      var request = args[0];
      var requestUrl = typeof request === 'string' ? request : (request && request.url ? request.url : '');
      var isCartAdd = /\/cart\/add(?:\.js)?(?:\?|$)/.test(requestUrl);
      return originalFetch.apply(window, args).then(function (response) {
        if (!isCartAdd || !response.ok) return response;
        response.clone().json().then(function (body) {
          cartHasItems = true;
          trackAddToCart(attribution, detailFromCartAdd(body, 'confirmed-cart-add'));
        }).catch(function () {
          // A successful non-JSON response is left to the theme cart event.
        });
        return response;
      });
    };
  }

  function syncAttribution(attribution) {
    if (!attribution) return;
    var syncValue = attribution.slug + '|' + attribution.campaign + '|' + attribution.linkCode + '|' + String(attribution.capturedAt || '');
    if (storageGet(window.sessionStorage, SYNC_KEY) === syncValue) return;

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          'OVN Affiliate Slug': attribution.slug,
          'OVN Affiliate Campaign': attribution.campaign || '',
          'OVN Affiliate Link': attribution.linkCode || '',
          'OVN Affiliate Captured At': new Date(Number(attribution.capturedAt || Date.now())).toISOString(),
          'OVN Affiliate Source': attribution.source || 'affiliate',
        },
      }),
    }).then(function (response) {
      if (response.ok) storageSet(window.sessionStorage, SYNC_KEY, syncValue);
    }).catch(function () {
      // Checkout remains usable if the optional attribution request fails.
    });
  }

  function healthPing() {
    var lastCheck = Number(storageGet(window.localStorage, HEALTH_KEY) || 0);
    if (Date.now() - lastCheck < HEALTH_TTL) return;
    storageSet(window.localStorage, HEALTH_KEY, String(Date.now()));
    if (Math.random() > 0.05) return;

    fetch('/apps/affiliate?health=1', {
      credentials: 'same-origin',
      headers: {accept: 'application/json'},
    }).catch(function () {
      // Health monitoring must never interrupt the storefront.
    });
  }

  var attribution = currentAttribution();
  syncAttribution(attribution);
  if (attribution && attribution.isNew) sendEvent('click', attribution);
  installConfirmedCartTracking(attribution);

  document.addEventListener('cart:update', function (event) {
    var detail = event.detail || {};
    if (detail.data && detail.data.didError) return;
    if (!detail.data || (!detail.data.productId && !detail.data.variantId)) return;
    trackAddToCart(attribution, detail);
  });

  document.addEventListener('click', function (event) {
    var checkout = event.target.closest('a[href*="/checkout"], button[name="checkout"], [data-ov-affiliate-checkout]');
    if (checkout && cartHasItems === true) sendEvent('checkout', attribution);
  }, true);

  healthPing();
})();
